import React, { lazy, Suspense, useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "moment/locale/de";
import { ReactComponent as Icons } from "./assets/icons.svg";

import Header from "./components/Header/Header";
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import GoogleAnalytics from "./components/GoogleAnalytics";
import CookieBannerGDPR from "./components/CookieBannerGDPR";
import Routing from "./Routing";
import ScrollToTop from "./utils/ScrollToTop";
import StagingPasswort from "./components/StagingPasswort";

const Home = lazy(() => import("./components/Home"));
const SearchResults = lazy(() => import("./components/SearchResults"));

const stagingPassword = process.env.REACT_APP_STAGING_PASSWORD;

const App = () => {
  const [statisticsCookieState, setStatisticsCookieState] = useState(false);
  const [marketingCookieState, setMarketingCookieState] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  // Standardmäßige Consent-Werte setzen
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }

    gtag("consent", "default", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      wait_for_update: 500,
    });

    if (!stagingPassword) {
      // Kein Passwort nötig
      setAuthenticated(true);
      setIsLoading(false);
      return;
    }

    const isAuth = localStorage.getItem("authenticated") === "true";
    setAuthenticated(isAuth);
    setIsLoading(false);
  }, []);

  if (isLoading) {
    // Während wir prüfen, ob Password gesetzt ist → nichts anzeigen
    return null;
  }

  if (!authenticated) {
    return <StagingPasswort onLogin={() => setAuthenticated(true)} />;
  }

  const updateConsent = (consent) => {
    setStatisticsCookieState((prev) =>
      consent.analytics !== undefined ? consent.analytics : prev
    );
    setMarketingCookieState((prev) =>
      consent.marketing !== undefined ? consent.marketing : prev
    );

    let updatedConsent = {
      analytics_storage:
        consent.analytics !== undefined
          ? consent.analytics
            ? "granted"
            : "denied"
          : statisticsCookieState
          ? "granted"
          : "denied",
      ad_storage:
        consent.marketing !== undefined
          ? consent.marketing
            ? "granted"
            : "denied"
          : marketingCookieState
          ? "granted"
          : "denied",
      ad_user_data:
        consent.marketing !== undefined
          ? consent.marketing
            ? "granted"
            : "denied"
          : marketingCookieState
          ? "granted"
          : "denied",
      ad_personalization:
        consent.marketing !== undefined
          ? consent.marketing
            ? "granted"
            : "denied"
          : marketingCookieState
          ? "granted"
          : "denied",
    };

    setTimeout(() => {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }

      window.dataLayer.push({
        event: "consent_update",
        consent: updatedConsent,
      });
    }, 0);
  };

  if (!authenticated) {
    return <StagingPasswort onLogin={() => setAuthenticated(true)} />;
  }

  return (
    <main>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <React.Fragment>
          <Icons style={{ display: "none" }} />
          <div className="main" id="top">
            <Header />
            <GoogleAnalytics cookieState={statisticsCookieState} />
            <Suspense fallback={<Loader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route
                  path="/suche/:suchanfrage"
                  element={<SearchResults />}
                />
                <Route path="/*" element={<Routing />} />
              </Routes>
            </Suspense>
            <Footer cookieState={marketingCookieState} />
          </div>
        </React.Fragment>
      </BrowserRouter>

      <CookieBannerGDPR onConsentUpdate={updateConsent} />
    </main>
  );
};

export default App;
